import * as R from "ramda";
import { i18n } from "../../../i18n";
import { get } from "lodash";

import { getGridItemClass } from "../../../store/global/gridlayout";
import { FormFuncs } from "../../../store/global/form-data.model";

// import { documentGetters } from './documents/getters';
// import { travelDetailsGetters } from './travel-details/getters';
// import { localDeailsGetters } from './local-details/getters';

import { bookingsGetters } from "./bookings/getters";
import { venueGetters } from "./venues/getters";
import { bookingPluginsGetters } from "./plugins/getters";
import { artistGetters } from "./artists/getters";
import { bookingReportsGetters } from "./reports/getters";
import { bookingPromotersGetters } from "./promoters/getters";
import { templateGetters } from "./templates/getters";


import { BookingArtist } from "../models/booking-artist.model";
import { contactIdPromoterView, usersView, userView } from "../models/booking-overview.model";
import { createArtist } from "../models/artist.model";
import { getFilterColor } from "../models/status-colors";
import { checkTabListPermission } from "../../../router/guard";

import { toursGetters } from './tours/getters'
import { BookingModulePluginStore } from "./plugins";
const BOOKING_STATUS_NAME = "booking_status_name";






export const getters = {
  ...bookingsGetters,

  ...artistGetters,
  ...bookingPromotersGetters,
  ...bookingReportsGetters,
  ...venueGetters,

  ...BookingModulePluginStore.getters,

  ...toursGetters,
  ...templateGetters
};
